<template>
    <modal @close="$emit('close')" :show-title="true" :size="'medium'">
        <div slot="header">
            <h5 class="modal-title">{{$t('ordine.dettagli_allergeni')}}</h5>
        </div>
        <div slot="body">
            <b>{{$t('ordine.allergeni_contenuti_label')}}:</b>
            <br><br>
            <p v-for="allergen in this.allergens">
                <img :src="'/img/be/allergeni/'+allergen.icona+'.png'">&nbsp;&nbsp;{{allergen.nome}}<span v-if="allergen.ingredients && allergen.ingredients.length">:</span>
              <b v-if="allergen.ingredients && allergen.ingredients.length">
                {{ removeDoubleIngredients(allergen.ingredients).join(', ') }}
              </b>
            </p>
            <hr>
            <br>
            <p class="text-justify">{{$t('ordine.allergeni_informazioni_text')}}</p>
        </div>
        <div slot="footer" class="flex-fill">
            <button type="button" class="btn btn-primary" @click="$emit('close')">
                {{$t('ordine.grazie_ok')}}
            </button>
        </div>
    </modal>
</template>

<script>
    import Modal from '../../partials/Modal';

    export default {
        name: "ModalAllergens",
        components: {Modal},
        props: ['allergens'],

      methods: {
          removeDoubleIngredients: function(ingredients){
            return ingredients.filter((ingredient, index) => {
              return ingredients.indexOf(ingredient) === index
            })
          }
      }
    }
</script>
